import React from 'react';
import './EndSlide.css'
import { QuizResult } from '../../../models/Quiz';

interface EndSlideProps {
  quizResults: QuizResult | null
}

function EndSlide({ quizResults }: EndSlideProps) {

  return (
    <div className="end-slide slide">
      {quizResults &&
        <>
          <h2>You are a {quizResults.personalityType}</h2>
          <div className='results-container'>
            <div className='results-section'>
              <img src={`/images/quiz-images/quiz-result-image-${quizResults.personalityId + 1}.jpg`} alt='Personality type' />
              <div>
                <div className='results-text-section'>
                  <h4>Strengths</h4>
                  <p>{quizResults.strengths}</p>
                </div>
                <div className='results-text-section'>
                  <h4>Challenges</h4>
                  <p>{quizResults.challenges}</p>
                </div>
                <div className='results-text-section'>
                  <h4>One Step Forward</h4>
                  <p>{quizResults.oneStepForward}</p>
                </div>
              </div>
            </div>
            <p className='cta'>{quizResults.cta}</p>
            <p>Be sure to check your inbox too — I’ve sent you a copy of your Empowered Mom Style so you can revisit it anytime.</p>
          </div>
        </>
      }
    </div>
  );
};

export default EndSlide;